import { TranslateService } from '@ngx-translate/core';

import { ModalController } from '@ionic/angular';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Peripheral } from 'src/app/_model/peripheral';
import {
  PeripheralConfigFactoryService,
  PeripheralConfigStep,
} from 'src/app/_services/peripherals/peripherals-config-factory';
import { PeripheralsService } from 'src/app/_services/peripherals/logic/peripherals.service';
import { DataListComponent } from '../data-list/data-list.component';
import { Observable } from 'rxjs';
import { DataListViewModelItem } from '../data-list/data-list-view-model';
import { map } from 'rxjs/operators';
import { BluetoothDevice } from 'plugins/lbs-peripherals/src';
import { LoadingService } from 'src/app/_services/loading/loading.service';
import { IMSComponent } from 'src/app/_util/ims-component';

@Component({
  selector: 'app-peripheral-connection-establish-modal',
  templateUrl: './peripheral-connection-establish-modal.component.html',
  styleUrls: ['./peripheral-connection-establish-modal.component.scss'],
})
export class PeripheralConnectionEstablishModalComponent extends IMSComponent {
  // ViewChilds
  @ViewChild('list', { static: false })
  dataList: DataListComponent<BluetoothDevice>;

  // Inputs
  @Input() modalId: string;
  @Input() peripheral: Peripheral;

  // Public Member
  public get currentConfigStep(): PeripheralConfigStep {
    return this.configSteps[this.currentStep];
  }
  public hasPreviousStep: boolean = true;
  public isLastStep: boolean = false;
  public configFinished: boolean = false;

  public btDeviceViewModel: Observable<
    DataListViewModelItem<BluetoothDevice>[]
  >;
  public placeholder = 'COMPONENT.BLUETOOTHDEVICES.EMPTY';

  // Private Member
  private configSteps: PeripheralConfigStep[];
  private currentStep = 0;

  // Lifecycle
  constructor(
    logger: LoggingService,
    translate: TranslateService,
    private modalController: ModalController,
    private peripheralConfigFactory: PeripheralConfigFactoryService,
    private peripheralsService: PeripheralsService,
    private loadingService: LoadingService,
  ) {
    super(logger, translate);
    console.log('JB Construct Modal');
  }

  ngOnInit() {
    console.log('JB onInit Modal');
    super.ngOnInit;
    if (this.modalId == undefined) {
      this.logger.warn(
        this.constructor.name,
        'No modal id was provided - There might be problems dismissing the modal',
      );
    }
    console.log('JB onInit Modal', this.modalId, this.peripheral?.name);
    console.log(
      this.constructor.name,
      'PeripheralConnectionEstablishModalComponent opened for peripheral',
      this.peripheral?.name,
    );
    this.configSteps = this.peripheralConfigFactory.configStepsForPeripheral(
      this.peripheral,
    );
    console.log('JB onInit Modal configSteps', this.configSteps);
    this.currentStep = 0;
    console.log('JB onInit Modal currentStep', this.currentStep);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  // Public Functions
  public async back() {
    this.logger.log(this.constructor.name, 'back clicked');
    if (this.currentStep <= 0) {
      return;
    }

    this.currentStep -= 1;
    if (this.currentStep === 0) {
      this.hasPreviousStep = false;
    }

    this.isLastStep = false;
  }
  public async next() {
    this.logger.log(this.constructor.name, 'next clicked');
    this.currentStep += 1;

    if (this.currentStep >= this.configSteps.length - 1) {
      this.isLastStep = true;
    }
    this.hasPreviousStep = true;
  }
  public async skip() {
    const curStep = this.currentConfigStep;
    if (curStep.skip == true) {
      if (curStep.skipTo != undefined) {
        this.currentStep = curStep.skipTo;
      } else {
        this.currentStep = this.configSteps.length - 1;
        this.isLastStep = true;
      }
    }
    this.hasPreviousStep = true;
  }

  public async action() {
    const curStep = this.currentConfigStep;
    if (curStep.action != undefined) {
      curStep.action();
    }
  }

  public async finishConfig() {
    this.logger.log(this.constructor.name, 'finishConfig clicked');
    await this.loadingService.showLoading();
    this.btDeviceViewModel = this.peripheralsService.bluetoothDevices$.pipe(
      map((btDevices) =>
        btDevices.map((btDevice) => {
          let viewItem: DataListViewModelItem<BluetoothDevice>;

          viewItem = {
            id: btDevice,
            title: btDevice.name,
            titleTranslate: false,
            subtitle: btDevice.mac,
            subtitleTranslate: false,
            text:
              btDevice.paired == true
                ? 'COMPONENT.PERIPHERAL-CONNECTION.DEVICE-PAIRED'
                : undefined,
            textTranslate: true,
            textColor: 'dark',
            click: async (device) => {
              await this.loadingService.showLoading();
              console.log('Clicked on btDevice', device);
              await this.peripheralsService.connectPeripheral(
                this.peripheral,
                device,
              );
              this.modalController.dismiss(
                {
                  canceled: false,
                },
                undefined,
                this.modalId,
              );
              await this.loadingService.dismissLoading();
            },
          };
          return viewItem;
        }),
      ),
    );
    const result = await this.peripheralsService.connectPeripheral(
      this.peripheral,
    );
    if (!result.success) {
      await this.loadingService.dismissLoading();
      return;
    }
    if (result.btScanStarted) {
      await this.loadingService.dismissLoading();
      this.configFinished = true;
    } else {
      await this.loadingService.dismissLoading();
      this.modalController.dismiss(
        {
          canceled: false,
        },
        undefined,
        this.modalId,
      );
    }
  }

  public async cancel() {
    this.logger.log(
      this.constructor.name,
      'Peripheral Connection Establish was canceled',
    );
    await this.peripheralsService.stopScanIfNecessary(this.peripheral);

    this.modalController.dismiss(
      {
        canceled: true,
      },
      undefined,
      this.modalId,
    );
  }

  // Private Functions
}
